import React from 'react'

const ContractDeleteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22.1667 22.6624L19.6875 25.1124L18.0542 23.4791L20.5042 20.9999L18.0542 18.5208L19.6875 16.8874L22.1667 19.3374L24.6458 16.8874L26.2792 18.5208L23.8292 20.9999L26.2792 23.4791L24.6458 25.1124L22.1667 22.6624ZM7 25.6666C6.02778 25.6666 5.20139 25.3263 4.52083 24.6458C3.84028 23.9652 3.5 23.1388 3.5 22.1666V18.6666H7V2.33325H24.5V14.4374C24.1306 14.3013 23.7514 14.1992 23.3625 14.1312C22.9736 14.0631 22.575 14.0291 22.1667 14.0291V4.66659H9.33333V18.6666H15.575C15.4389 19.036 15.3368 19.4152 15.2688 19.8041C15.2007 20.193 15.1667 20.5916 15.1667 20.9999H5.83333V22.1666C5.83333 22.4971 5.94514 22.7742 6.16875 22.9978C6.39236 23.2214 6.66944 23.3333 7 23.3333H15.575C15.7306 23.7805 15.925 24.1985 16.1583 24.5874C16.3917 24.9763 16.6639 25.336 16.975 25.6666H7ZM10.5 10.4999V8.16659H21V10.4999H10.5ZM10.5 13.9999V11.6666H21V13.9999H10.5Z'
      fill='currentcolor'
    />
  </svg>
)

export default ContractDeleteIcon
